import { PdfDocumentType } from '@zinnia/form-engine-sdk';

// A node with no own selection inherits its parent's effective PDF types.
export function resolveEffectivePdfDocumentTypes(
  ownValue: PdfDocumentType[] | undefined,
  parentEffectiveTypes: PdfDocumentType[],
): PdfDocumentType[] {
  return ownValue?.length ? ownValue : parentEffectiveTypes;
}

// Selecting one of these on this node has no effect: the parent chain already excludes it
// from that PDF, so it will never render there regardless of this node's own tag.
export function getPdfDocumentTypesNotInParent(
  ownValue: PdfDocumentType[] | undefined,
  parentEffectiveTypes: PdfDocumentType[],
): PdfDocumentType[] {
  if (!ownValue?.length) {
    return [];
  }
  return ownValue.filter((type) => !parentEffectiveTypes.includes(type));
}
